import { render, staticRenderFns } from "./SmartPillboxSetting.vue?vue&type=template&id=5bdf4252&scoped=true"
import script from "./SmartPillboxSetting.vue?vue&type=script&lang=js"
export * from "./SmartPillboxSetting.vue?vue&type=script&lang=js"
import style0 from "./SmartPillboxSetting.vue?vue&type=style&index=0&id=5bdf4252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdf4252",
  null
  
)

export default component.exports